<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="500px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Make a deposit</span>
        <v-btn
          text
          icon
          dark
          @click="
            () => {
              $emit('update:isActive', false);
              resetForm();
            }
          "
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="paymentType"
          :method="method"
          :action="url"
          @on-error="$emit('on-fail', $event)"
          @submitted="onSuccess($event)"
          @input:amount_without_fees_in_euro="updateFees"
          ref="form"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-user-search
                  name="recipient_id"
                  label="Select the receiver"
                  item_name="full_name"
                  item_value="id"
                  icon="mdi-account-search"
                  @changed="updateBankAccounts"
                />
              </v-col>
              <v-col cols="12">
                <custom-select
                  name="cashin_method_id"
                  :items="cashin_methods"
                  @changed="handleCashinMethods"
                  label="Select the cashin method"
                  :disabled="isLoading"
                />
              </v-col>
              <v-col cols="12" v-if="bankTransferOrInstantSepa">
                <custom-select
                  name="bank_account_id"
                  :items="admin_bank_accounts"
                  item-value="id"
                  item-text="title"
                  label="Select the user Bank Account"
                  :disabled="isLoading"
                  @changed="(e) => (bank_account_id = e)"
                />
                <div class="mb-6">
                  <span>Fees : €{{ fee }}</span>
                </div>
              </v-col>
              <v-col cols="12">
                <custom-input
                  name="amount_without_fees_in_euro"
                  :disabled="isLoading"
                  label="Amount(Euro)"
                />
              </v-col>
              <v-col cols="12">
                <custom-button
                  :loading="isLoading"
                  :isDisabled="
                    isLoading ||
                    selected_user == null ||
                    amount == 0 ||
                    amount == undefined ||
                    (admin_bank_accounts.length < 1 &&
                      (bankTransferOrInstantSepa || bankTransferOrInstantSepa == 'undefined')) ||
                    selected_cashin_method_id == null ||
                    selected_cashin_method_id == undefined
                  "
                  block
                  color="primary"
                >
                  Confirm
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    paymentType: {
      default: () => {},
      type: Object,
    },
  },

  data() {
    return {
      selected_cashin_method_id: null,
      fee: 0,
      selected_user: null,
      cashin_methods_data: [],
      admin_bank_accounts: [],
      sender_bank_accounts: [],
      amount: 0,
      bank_account_id: null,
      isLoading: false,
      bankTransferOrInstantSepa: false,
    };
  },
  computed: {
    url() {
      return "api/v1/payments/initiatePayinFromBackOffice";
    },
    cashin_methods() {
      return this.getSelectOptions(this.cashin_methods_data);
    },
  },
  methods: {
    onSuccess(value) {
      this.$emit("changed", value);
      this.resetForm();
    },
    resetForm() {
      this.$refs.form.resetForm();
      (this.selected_cashin_method_id = null),
        (this.fee = 0),
        (this.selected_user = null),
        (this.cashin_methods_data = []),
        (this.admin_bank_accounts = []),
        (this.sender_bank_accounts = []),
        (this.amount = 0),
        (this.bank_account_id = null)((this.bankTransferOrInstantSepa = false));
    },
    getSelectOptions(data) {
      return data.map(({ cash_in_method }) => ({
        value: cash_in_method.id,
        text: cash_in_method.name,
      }));
    },
    handleCashinMethods(value) {
      const cashInMethod = this.cashin_methods_data.find(
        (cashinMethod) => cashinMethod.cash_in_method.id == value,
      );
      if (cashInMethod.cash_in_method && cashInMethod.cash_in_method.name !== undefined) {
        if (
          cashInMethod.cash_in_method.name.toLowerCase() == "bank transfer" ||
          cashInMethod.cash_in_method.name.toLowerCase() == "instant sepa"
        ) {
          this.bankTransferOrInstantSepa = true;
        } else {
          this.bankTransferOrInstantSepa = false;
        }
      } else {
        this.bankTransferOrInstantSepa = false;
      }
      this.selected_cashin_method_id = value;
      this.calculateFees(this.amount);
    },
    async updateBankAccounts(user_id) {
      if (user_id !== undefined) {
        this.isLoading = true;
        await this.$http
          .get(`/api/v1/users/${user_id}`)
          .then((response) => {
            this.selected_user = response;
            this.fetchData();
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.selected_user = null;
      }
    },

    updateFees: debounce(function (value) {
      this.calculateFees(value);
    }, 500),
    getUserOptions(data) {
      return data.map(({ id, full_name }) => ({ value: id, text: full_name }));
    },
    calculateFees(value) {
      this.amount = value;
      if (
        value !== undefined &&
        this.selected_user &&
        this.selected_user.id &&
        this.selected_user.id !== undefined
      ) {
        this.isLoading = true;
        this.$http
          .post(`/api/v1/payments/getEuroAppliedFees/transfer/${this.selected_user.id}`, {
            cashin_method_id: this.selected_cashin_method_id,
            euro_amount: value,
            sending_country_id: this.selected_user.country_id,
          })
          .then((response) => {
            this.fee = parseFloat(response.fee).toFixed(2);
          })
          .catch(() => (this.fee = 0))
          .finally(() => (this.isLoading = false));
      } else {
        this.isLoading = false;
      }
    },
    async fetchData() {
      await this.$http
        // .get("/api/v1/transactions/transferCashInMethods/all?name=bank transfer")
        .get(
          `/api/v1/transactions/transferCountries/${this.selected_user.country_id}/cashInMethods`,
        )
        .then((response) => {
          this.cashin_methods_data = response.data;
        })
        .catch(() => (this.cashin_methods_data = []));

      await this.$http
        .get(`/api/v1/userBankAccounts/all/${this.selected_user.id}`)
        .then((response) => {
          this.admin_bank_accounts = response.data;
        });
    },
  },
};
</script>
